import React, { useRef } from 'react'

import img1 from 'assets/images/distributionPage/mobile-coin-1.png'
import img2 from 'assets/images/distributionPage/mobile-coin-2.png'
import img3 from 'assets/images/distributionPage/mobile-coin-3.png'
import img4 from 'assets/images/distributionPage/mobile-coin-4.png'

import classes from './MobileBackground.module.scss'

export const MobileDistributionBackground = (): JSX.Element => {
  const images = [img1, img2, img3, img4]

  const refs = useRef<HTMLImageElement[]>([])

  return (
    <div className={classes.wrapper}>
      {images.map((img, imgIndex) => {
        return (
          <img
            ref={el => ((refs.current[imgIndex] as any) = el)}
            className={classes.img}
            src={img}
            key={imgIndex}
            alt=""
          />
        )
      })}
    </div>
  )
}
